import axios from "@/utils/http"
class AppMarketApi {
    static getInstance() {
        if (!this.instance) {
            this.instance = new AppMarketApi();
        }
        return this.instance;
    }
    // 列表查询应用 
    listAppStore(body) {
        return axios.postCom(window.Glod['ccex-appstore'] + "/store/api/product/getProductList", body)
    }
    // 列表查询应用-行业推荐
    getRecommendIndustry(body) {
        return axios.postCom(window.Glod['ccex-appstore'] + "/store/api/product/getRecommendIndustry", body)
    }
    //查看应用详情 
    detailAppStore(body) {
        return axios.postCom(window.Glod['ccex-appstore'] + "/store/api/product/getMallProductDetail", body)
    }
    //来自同一个供应商的产品
    getSameProviderProducts(body) {
        return axios.postCom(window.Glod['ccex-appstore'] + "/store/api/product/getSameProviderProducts", body )
    }
    // 判断商品有没有购买过
    getProductStatus(body) {
        return axios.getCom(window.Glod['ccex-appstore'] + "/api/order/hasPurchased/"+ body)
    }
    // 创建应用订单
    createOrder(body) {
        return axios.postCom(window.Glod['ccex-appstore'] + "/api/order/create", body)
    }
    // 取消订单
    cancelOrder(body) {
        return axios.postCom(window.Glod['ccex-appstore'] + "/api/order/cancel", body)
    }
    // 首页推荐 
    getRecommendedProducts(body) {
        return axios.postCom(window.Glod['ccex-appstore'] + "/store/api/product/getRecommendedProducts", body)
    }
    // 首页最新
    getTheLastestProducts(body) {
        return axios.postCom(window.Glod['ccex-appstore'] + "/store/api/product/getTheLastestProducts", body)
    }
    // 首页统计
    getStatisticalQuantity(body) {
        return axios.postCom(window.Glod['ccex-appstore'] + "/store/api/product/getStatisticalQuantity", body)
    }
    // solutions分组查看应用 
    solutionsGroupList(body) {
        return axios.postCom(window.Glod['ccex-appstore'] + "/store/api/product/group", body)
    }
    // 查询我的订单/应用列表
    getMyOrderList(body) {
        return axios.postCom(window.Glod['ccex-appstore'] + "/store/api/order/queryOrderListByType", body)
    }
    // 查询我的订单/订单明细
    queryOrderById(body) {
        return axios.postCom(window.Glod['ccex-appstore'] + "/store/api/order/queryOrderById", body)
    }
    // 查询我的订单/订单详情
    queryOrderInfoById(body) {
        return axios.postCom(window.Glod['ccex-appstore'] + "/store/api/order/queryOrderInfoById", body)
    }
    // 能否升级
    checkUpgrade(body) {
        return axios.getCom(window.Glod['ccex-appstore'] + "/api/order/checkUpgrade/" + body)
    }
    // 升级
    upgrade(body) {
        return axios.postCom(window.Glod['ccex-appstore'] + "/api/order/upgrade", body)
    }
    // 申请演示-成为潜在客户
    createLead(body) {
        return axios.postCom(window.Glod['ex-openaccount-svc'] + "/web/probation/create/createLead", body)
    }
    
    // 获取用户基本信息
    getUserBasicInfo(body) {
        return axios.postCom(window.Glod['ccex-appstore'] + "/store/api/mallUser/getMallUserInfo", body)
    }
    
    // 保存用户基本信息
    updateUserBasicInfo(body) {
        return axios.postCom(window.Glod['ccex-appstore'] + "/store/api/mallUser/saveMallUserInfo", body)
    }
    
    // 用户密码修改
    userPwModify(body) {
        return axios.postCom(window.Glod['ccex-setup'] + "/api/accessApi/login/userPwModify", body)
    }
    
    // 验证手机号是否重复
    verifyPhone(body) {
        return axios.postCom(window.Glod['ccex-appstore'] + "/store/api/mallUser/verifyPhone", body)
    }
    
    // 上传头像图片
    uploadImg(data) {
        return axios.postCom(window.Glod['ccex-api-svc'] + "/api/file/uploadImg", data, "", {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    }
    
    // 根据文件ID获取图片预览URL
    viewImg(id) {
        const baseUrl = window.Glod['ccex-api-svc'];
        const token = window.$CCDK.CCToken.getToken("binding", "partnerToken");
        return `${baseUrl}/api/file/viewImg?id=${id}&accessToken=${token}`;
    }
    
}
export default AppMarketApi;